import { useApiQuery } from "../../../services/api";
import { useIsRoomMember } from "../../room/hooks/useIsRoomMember";

/**
 * Whether the podcast page may ask for the room's podcast list, which it reads
 * to find the same show in the reader's language.
 *
 * That list is members-only (`guardRoom`: a member, or a public room). A
 * podcast opens from a shared link for anyone, so a non-member often stands on
 * the page, and a request that answers 403 is reported to Sentry as an error on
 * every such visit.
 *
 * The room's flags come from its PUBLIC card, which answers everyone: the
 * private row would itself answer 403 to the same reader.
 */
export function useCanListRoomPodcasts(roomId: string): boolean {
  const isMember = useIsRoomMember(roomId);
  const cardQuery = useApiQuery("/webapp/public/rooms/:roomId", {
    param: { roomId },
    query: {},
  });
  if (isMember) return true;
  return cardQuery.state === "success" && cardQuery.body.isPublic;
}
